import { ArnHttpConditionService } from './ArnHttpConditionService';
import { ArnDelegateConditionService } from '../ArnDelegateConditionService';
import {
  ArnConditionExecutionOptions,
  ArnConditionService,
} from '../ArnConditionService';
import {
  ArnConditionsPayload,
  ArnHttpConditionRequest,
  ArnHttpConditionResponse,
  MatchHttpResponseCondition,
} from '@arianee/arn-types';

export class DefaultHttpConditionService
  extends ArnDelegateConditionService
  implements ArnHttpConditionService
{
  static readonly CONDITION_HTTP = 'hasHttpResponseForRequest';

  constructor(condition: ArnConditionService) {
    super(condition);
  }

  async requestReturns(
    request: ArnHttpConditionRequest,
    response: ArnHttpConditionResponse,
    options?: ArnConditionExecutionOptions
  ): Promise<boolean> {
    const conditionsPayload: ArnConditionsPayload = {
      and: [
        new MatchHttpResponseCondition({
          name: DefaultHttpConditionService.CONDITION_HTTP,
          request,
          response,
        }),
      ],
    };
    const result = await this.condition.execute(conditionsPayload, options);
    return result.success;
  }
}
